import React from 'react'

const InfoButton = () => {
    return (
        <svg className='info-btn-icon' data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1179.8 1179.8">
            <path d="M590,0C265.1.1.1,262.1,0,589.6c-.1,327.1,263.8,590,589.5,590.2,327.9.2,590-265.2,590.3-589.9C1179.8,264.3,915.6-.1,590,0ZM593.2,1033.1c-33.5.1-103.6-13.7-103.6-95.5.2-144.8.6-289.6-.2-434.4-.2-41.4,25.3-78,63.4-91.5,39.9-14.1,77.1-8.1,109.1,20.5,20.3,18.1,30.1,41.4,30,68.9-.2,72.7-.1,145.3-.1,218s-1,143.3.3,214.9c1,58.3-48.5,98.9-98.9,99.1ZM590,363.8c-60,0-108.9-48.8-109-108.7-.1-60.6,48.3-109.1,108.9-109.1s108.7,48.1,108.8,108.5c0,60.7-48.3,109.3-108.7,109.3Z" />
        </svg>
    )
}

export default InfoButton
